<template>
  <div class="rt-address">
    <div class="address-select-all">
      <div class="address-select">
        <el-select
          :disabled="disabled"
          v-model="address.province[alias.id]"
          placeholder="省"
          @focus="focus1"
          @blur="blur1"
          @change="provinceChange"
        >
          <el-option
            v-for="(item, index) in provinces"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          />
        </el-select>
        <rt-icon v-if="!disabled" name="rt-base-dropdown" color="#a9c2e8" />
      </div>
      <div class="address-select">
        <el-select
          :disabled="disabled"
          v-model="address.city[alias.id]"
          placeholder="市"
          @focus="focus2"
          @blur="blur2"
          @change="cityChange"
        >
          <el-option
            v-for="(item, index) in cities"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          />
        </el-select>
        <rt-icon v-if="!disabled" name="rt-base-dropdown" color="#a9c2e8" />
      </div>
      <div class="address-select">
        <el-select
          :disabled="disabled"
          v-model="address.country[alias.id]"
          placeholder="县/区"
          @focus="focus3"
          @blur="blur3"
          @change="countryChange"
        >
          <el-option
            v-for="(item, index) in countries"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          />
        </el-select>
        <rt-icon v-if="!disabled" name="rt-base-dropdown" color="#a9c2e8" />
      </div>
      <div :class="{ focusInSelect: focusInSelect }" class="rt-input-shadow" />
    </div>
    <div class="address-input">
      <rt-input
        :disabled="disabled"
        v-model="address.address"
        @focus="focusInput"
        @blur="blurInput"
        @change="addressChange"
      />
      <div :class="{ focusInInput: focusInInput }" class="rt-input-shadow" />
    </div>
  </div>
</template>

<script>
import config from '../../config';
export default {
  name: 'RtAddress',
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected1: false,
      selected2: false,
      selected3: false,
      focusInInput: false,
      address: {
        province: {},
        city: {},
        country: {}
      },
      provinces: [],
      cities: [],
      countries: [],
      config: {},
      alias: {}
    };
  },
  computed: {
    focusInSelect() {
      if (this.selected1 || this.selected2 || this.selected3) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value(newValue) {
      this.address = JSON.parse(JSON.stringify(newValue));
      let { alias } = this;
      if (this.address.province[alias.id]) {
        this.getCities();
      }
      if (this.address.city[alias.id]) {
        this.getCountries();
      }
    }
  },
  mounted() {
    this.config = config.get();
    this.alias = this.config.address.alias;
    let provinceUrl = this.config.address.provinceUrl;
    rt.get(provinceUrl).then(res => {
      this.provinces = res;
    });
  },
  methods: {
    getCities() {
      let citiesUrl = this.config.address.cityUrl;
      let data = {
        id: this.address.province[this.alias.id]
      };
      rt.get(citiesUrl).then(res => {
        this.cities = res;
      });
    },
    getCountries() {
      let countriesUrl = this.config.address.countyUrl;
      let data = {
        id: this.address.city[this.alias.id]
      };
      rt.get(countriesUrl).then(res => {
        this.countries = res;
      });
    },
    provinceChange() {
      this.address.city = {};
      this.address.country = {};
      this.address.address = '';
      if (this.address.province) {
        this.provinces.map(item => {
          if (item[this.alias.id] === this.address.province[this.alias.id]) {
            this.address.province[this.alias.name] = item[this.alias.name];
          }
        });
        this.getCities();
        this.change();
      }
    },
    cityChange() {
      this.address.country = {};
      this.address.address = '';
      if (this.address.city) {
        this.cities.map(item => {
          if (item[this.alias.id] === this.address.city[this.alias.id]) {
            this.address.city[this.alias.name] = item[this.alias.name];
          }
        });
        this.getCountries();
        this.change();
      }
    },
    countryChange() {
      this.address.address = '';
      if (this.address.country) {
        this.countries.map(item => {
          if (item[this.alias.id] === this.address.country[this.alias.id]) {
            this.address.country[this.alias.name] = item[this.alias.name];
          }
        });
        this.change();
      }
    },
    addressChange() {
      this.address.address = this.address.address;
      this.change();
    },
    change() {
      this.$emit('input', this.address);
    },
    focus1() {
      this.selected1 = true;
    },
    blur1() {
      this.selected1 = false;
    },
    focus2() {
      this.selected2 = true;
    },
    blur2() {
      this.selected2 = false;
    },
    focus3() {
      this.selected3 = true;
    },
    blur3() {
      this.selected3 = false;
    },
    focusInput() {
      this.focusInInput = true;
    },
    blurInput() {
      this.focusInInput = false;
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-address {
  display: flex;
  .address-select-all {
    display: flex;
    flex: 1;
    position: relative;
    .address-select {
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-left: 8px;
      }
      &.rt-icon {
        margin-left: auto;
      }
      @{deep} {
        .el-select {
          .el-input {
            .el-input__inner {
              padding-right: 0;
            }
            .el-input__suffix {
              display: none;
            }
            .rt-input-shadow {
              display: none;
            }
          }
        }
      }
    }
  }
  .address-input {
    margin-left: 16px;
    position: relative;
    flex: 1;
  }
  .rt-input-shadow.focusInSelect,
  .rt-input-shadow.focusInInput {
    background-color: #1890ff;
    box-shadow: 0px 1px 3px 0px #1890ff;
  }
}
</style>



// WEBPACK FOOTER //
// rtAddress.vue?77a87674